// extracted by mini-css-extract-plugin
export var iconWrapper = "ItemIcon-module--iconWrapper--R4KuN";
export var thumbnail = "ItemIcon-module--thumbnail--YfcLv";
export var thumbnailBadge = "ItemIcon-module--thumbnailBadge--JOfv3";
export var thumbnailWrapper = "ItemIcon-module--thumbnailWrapper--i-RFd";